import analytics from "./analytics";
import autoComplete from './auto-complete';
import confirm from './confirm';
import confirmUpgrade from "./confirm-upgrade";
import focus from './focus';
import lazysvg from './lazysvg';
import linkDropdown from './link-dropdown';
import popup from './popup';
import popupCams from './popup-cams';
import restricted from './restricted';
import restrictedListen from './restricted-listen';
import scrollToComments from "./scroll-to-comments";
import drop from "./drop";
import observeIntersect from "./observe-intersect";
import roll from "./roll";
import tracker from "./tracker";
import address from "./address";
import cerebro from "./cerebro";
import tracking from "./tracking";



export default {
    analytics,
    'auto-complete': autoComplete,
    confirm,
    'confirm-upgrade': confirmUpgrade,
    focus,
    lazysvg,
    'link-dropdown': linkDropdown,
    popup,
    'popup-cams': popupCams,
    restricted,
    'restricted-listen': restrictedListen,
    'scroll-to-comments': scrollToComments,
    'drop': drop,
    'roll': roll,
    'observe-intersect': observeIntersect,
    'tracker': tracker,
    'address': address,
    'cerebro': cerebro,
    'tracking': tracking,
}
